import Dataman from 'App/Dataman';

const EXCLUDED_DEAL_ID = [1];

export function loadWebsiteDeals() {
  return Dataman.DB.getDealTypes().then((res) => {
    return res.data['hydra:member']
      .filter((el) => !EXCLUDED_DEAL_ID.includes(el.id))
      .map((el) => ({ text: el.name, value: el.id }));
  });
}
